const playButtons = document.querySelectorAll('.full-width-video .play-button');


playButtons.forEach((play) => {
    play.addEventListener('click', playVideo);

})

function playVideo(event) {
    event.preventDefault();
    const fullPlayButton = event.target.closest('.play-button');
    fullPlayButton.classList.add('hidden');
    const videoContainer = event.target.closest('.full-width-video');
    const video = videoContainer.querySelector('.video');
    video.play();
    video.setAttribute('controls', '');
}